import { CatalogService } from './../services/catalog.service';
import { ActionService } from './../services/action.service';
import { MessageService } from '../services/message.service';
import { Message } from '../common/message';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material';
import { ConfirmDeleteDialogComponent } from '../dialog/confirm-delete-dialog/confirm-delete-dialog.component';
import { Action } from '../models/action';
import { PowertrainService } from '../services/powertrain.service';
import { Enums } from '../common/enums';

let ELEMENT_DATA = [];

@Component({
  selector: 'app-visit-actions',
  templateUrl: './visit-actions.component.html',
  styleUrls: ['./visit-actions.component.scss']
})
export class VisitActionsComponent implements OnInit {

  form: FormGroup;
  submitted = false;
  success = false;
  ELEMENT_DATA: any[];
  displayedColumns: string[] = ['sn', 'category', 'name', 'desc','actions'];
  dataSource = new MatTableDataSource();

  @ViewChild(MatPaginator) paginator: MatPaginator;

  isFormDisplay: boolean = false;
  isAddNew: boolean = true;
  resource:Action = new Action();
  actionType = Enums.actionType ;

  constructor(
    private dialog : MatDialog, 
    private service: ActionService, 
    private formBuilder: FormBuilder,
    private msg : MessageService) { }

  ngOnInit() {
    this.setMessageForm();
    this.getResources();
  }

  setMessageForm() {
    this.form = this.formBuilder.group({
      sn: ['', Validators.required],
      name: ['', Validators.required],
      category: ['', Validators.required],
      desc: ['', Validators.required],
    });
  }

  getResources() {
    ELEMENT_DATA  = [];
    this.service.getAll()
      .subscribe(result => {
        ELEMENT_DATA = ELEMENT_DATA.concat(result);
        this.updateDataSource();
      })
  }

  updateDataSource() {
    this.dataSource = new MatTableDataSource<any>(ELEMENT_DATA);
    this.dataSource.paginator = this.paginator;
  }

  displayForm() {
    this.isFormDisplay = true;
  }

  displayTable() {
    this.isFormDisplay = false;
    this.resetForm();
  }

  onSave() {

    this.submitted = true;

    if(!this.resource || !this.resource.sn || this.resource.sn.trim() == ''){
      return;
    }

    
    if(!this.resource || !this.resource.name || this.resource.name.trim() == ''){
      return;
    }

    
    if(!this.resource || !this.resource.category || this.resource.category.trim() == ''){
      return;
    }

    if (this.form.controls.sn.errors) {
      return;
    }

    if (this.form.controls.name.errors) {
      return;
    }
    
    if (this.form.controls.category.errors) {
      return;
    }

    if (this.resource.id) {
      this.updateElement();
    } else {
      this.addElement();
    }

  }

  resetForm(ret? : boolean ) {
    this.resource.reset();
    this.form.reset();
    this.submitted = false;
    if(ret) this.isFormDisplay = false;
  }

  addElement() {
    this.service.create(this.resource)
      .subscribe(result => {
        this.msg.alert(Message.SAVE);
        ELEMENT_DATA.push(result);
        this.updateDataSource();
        //this.resource = new Engine();
        this.resetForm();
      })
  }

  updateElement() {
      this.service.update(this.resource)
      .subscribe(result => {
        this.msg.alert(Message.UPDATE);
        ELEMENT_DATA.forEach((elem, index) => {
          if (elem.id === this.resource.id){
            ELEMENT_DATA.splice(index, 1, result);
            return;
          }
        })

        this.updateDataSource();
        //this.resource = new Engine();
        this.resetForm(true);
      })
  }

  editElement(ele) {

    this.isFormDisplay = true;
    this.isAddNew = false;

    this.resource.setId(ele.id);
    this.resource.setName(ele.name);
    this.resource.setSn(ele.sn);
    this.resource.setDsec(ele.desc);
    this.resource.setCategory(ele.category);
  }

  deleteElement(ele) {
    this.dialog.open(ConfirmDeleteDialogComponent)
    .afterClosed()
    .subscribe(result => {
      if(result === "true"){
        this.service.delete(ele.id)
        .subscribe(result => {
          this.msg.alert(Message.DELETE);
          let index = ELEMENT_DATA.indexOf(ele);
          ELEMENT_DATA.splice(index, 1);
          this.updateDataSource();
        })
      }else{
        return;
      }
    });
    
  }

}
